module.exports = __webpack_public_path__ + "img/coupon_tutorial_ROMAPI02.e282d0d6.jpg";